module.exports = __webpack_public_path__ + "media/images/industrial-a83df54e7ccf2a36eec23b0728699ca5.png";